import React, { useState } from 'react';
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ForgotPasswordLink from '../components/ForgotPasswordLink';
import PasswordInput from '../components/PasswordInput';
import { useAuth } from '../authContext';
import { signInMarketplace } from '../lib/auth';
import { homePathForProfile } from '../lib/homePath';
import { theme } from '../lib/theme';
import BrandMark from '../components/BrandMark';

export default function MarketplaceLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { refresh } = useAuth();
  const passwordResetDone = location.state?.passwordReset || searchParams.get('reset') === 'done';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { profile, error: err } = await signInMarketplace(email, password);
      if (err) {
        setError(err.message);
        return;
      }
      await refresh();
      navigate(homePathForProfile(profile), { replace: true });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, color: theme.text, fontFamily: theme.font, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32, textDecoration: 'none' }}>
          <BrandMark size={34} decorative />
          <span style={{ fontWeight: 700, fontSize: 18, color: theme.text }}>Transport Team</span>
        </Link>
        <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 8 }}>Driver booking sign in</h1>
        <p style={{ color: theme.muted, marginBottom: 24, fontSize: 14 }}>For passengers and marketplace drivers</p>
        <form onSubmit={handleSubmit}>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" style={inputStyle} />
          <PasswordInput
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            style={{ marginTop: 12 }}
            inputStyle={inputStyle}
            toggleColor={theme.muted}
          />
          <ForgotPasswordLink scope="marketplace" linkColor={theme.accentLight} />
          {passwordResetDone ? (
            <p style={{ color: theme.accentLight, fontSize: 14, marginTop: 12 }}>
              Password updated. Sign in with your new password.
            </p>
          ) : null}
          {error && <p style={{ color: '#f87171', fontSize: 14, marginTop: 12 }}>{error}</p>}
          <button type="submit" disabled={busy} style={{ marginTop: 20, width: '100%', padding: 14, background: theme.accent, color: '#fff', border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer' }}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p style={{ marginTop: 20, fontSize: 14, color: theme.muted, textAlign: 'center' }}>
          No account? <Link to="/marketplace/register" style={{ color: theme.accentLight }}>Register</Link>
        </p>
        <p style={{ marginTop: 12, fontSize: 13, color: theme.dim, textAlign: 'center' }}>
          <Link to="/login" style={{ color: theme.muted }}>Organisation team sign in →</Link>
        </p>
      </div>
    </div>
  );
}

const inputStyle = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '12px 14px',
  borderRadius: 10,
  border: '1px solid rgba(255,255,255,0.12)',
  background: theme.bg1,
  color: theme.text,
  fontSize: 15,
};
